// \src\models\day-of-week.ts -->
export enum DayOfWeek {
  AllWeek = 0,
  Monday = 1,
  Tuesday = 2,
  Wednesday = 3,
  Thursday = 4,
  Friday = 5,
  Saturday = 6,
  Sunday = 7,
}

export interface DayOfWeekItem {
  name: string;
  value: DayOfWeek;
}
